/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GetReservationDurations200ResponseOneOf } from './GetReservationDurations200ResponseOneOf';
import {
    instanceOfGetReservationDurations200ResponseOneOf,
    GetReservationDurations200ResponseOneOfFromJSON,
    GetReservationDurations200ResponseOneOfFromJSONTyped,
    GetReservationDurations200ResponseOneOfToJSON,
} from './GetReservationDurations200ResponseOneOf';
import type { GetReservationDurations200ResponseOneOf1 } from './GetReservationDurations200ResponseOneOf1';
import {
    instanceOfGetReservationDurations200ResponseOneOf1,
    GetReservationDurations200ResponseOneOf1FromJSON,
    GetReservationDurations200ResponseOneOf1FromJSONTyped,
    GetReservationDurations200ResponseOneOf1ToJSON,
} from './GetReservationDurations200ResponseOneOf1';

/**
 * @type GetReservationDurations200Response
 * 
 * @export
 */
export type GetReservationDurations200Response = GetReservationDurations200ResponseOneOf | GetReservationDurations200ResponseOneOf1;

export function GetReservationDurations200ResponseFromJSON(json: any): GetReservationDurations200Response {
    return GetReservationDurations200ResponseFromJSONTyped(json, false);
}

export function GetReservationDurations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationDurations200Response {
    if (json == null) {
        return json;
    }
    if (instanceOfGetReservationDurations200ResponseOneOf(json)) {
        return GetReservationDurations200ResponseOneOfFromJSONTyped(json, true);
    }
    if (instanceOfGetReservationDurations200ResponseOneOf1(json)) {
        return GetReservationDurations200ResponseOneOf1FromJSONTyped(json, true);
    }

    return {} as any;
}

export function GetReservationDurations200ResponseToJSON(json: any): any {
    return GetReservationDurations200ResponseToJSONTyped(json, false);
}

export function GetReservationDurations200ResponseToJSONTyped(value?: GetReservationDurations200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfGetReservationDurations200ResponseOneOf(value)) {
        return GetReservationDurations200ResponseOneOfToJSON(value as GetReservationDurations200ResponseOneOf);
    }
    if (instanceOfGetReservationDurations200ResponseOneOf1(value)) {
        return GetReservationDurations200ResponseOneOf1ToJSON(value as GetReservationDurations200ResponseOneOf1);
    }

    return {};
}

